import { AugLoopRuntimeManager } from './AugLoopRuntimeManager';
import { SingleItemWorkflow } from '@augloop/runtime-client';
export class AugLoopFactory {
    constructor() {
        this._augLoopRuntimeManager = new AugLoopRuntimeManager();
    }
    getAugLoopRuntimeManager() {
        return this._augLoopRuntimeManager;
    }
    createSingleItemWorkflow(id) {
        return SingleItemWorkflow.create(id);
    }
}
/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const ALFactoryGlobal = new AugLoopFactory();
//# sourceMappingURL=AugLoopFactory.js.map